import React, { useEffect, useState } from "react";
import "./PanAdvance.css";

export default function PanAdvance() {

  const user = JSON.parse(localStorage.getItem("user"));
  const [pan, setPan] = useState("");
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  // LOAD HISTORY ALWAYS
  const loadHistory = async () => {
    const res = await fetch(
      `https://rcfinder.online/api/get_pan_advance.php?user_id=${user.id}`
    );

    const data = await res.json();
    if (data.status === "success") setHistory(data.list);
  };

  useEffect(() => {
    loadHistory();
  }, []);

  const handleSearch = async () => {

    if (!pan.trim()) {
      alert("Enter PAN Number");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://rcfinder.online/api/pan_advance.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id: user.id,
          pan
        })
      });

      const data = await res.json();
      console.log(data);

      if (data.status === "wallet_low") {
        alert("Wallet Low — Please Recharge");
      }
      else if (data.status !== "success") {
        alert(data.message || "Failed");
      }
      else {
        alert("PAN Details Fetched Successfully 🎉");
        loadHistory();
      }

    } catch (e) {
      alert("Server Error");
    }

    setLoading(false);
  };


  return (
    <div className="pan-wrapper">

      <h2 className="pan-title">PAN Premium (Advance) – ₹75</h2>

      {/* ================= TOP FLEX SECTION ================= */}
      <div className="pan-flex-box">

        {/* ================= INPUT CARD ================= */}
        <div className="pan-input-card">

          <input
            type="text"
            placeholder="Enter PAN Number"
            value={pan}
            maxLength={10}
            onChange={e => setPan(e.target.value.toUpperCase())}
          />

          <button onClick={handleSearch}>
            {loading ? "Please wait..." : "Get PAN Details"}
          </button>

        </div>


        {/* ================= INFO BOX ================= */}
        <div className="pan-info-box">
          <h4>What You Will Get?</h4>

          <ul>
            <li>✔ Full Name</li>
            <li>✔ Father Name</li>
            <li>✔ PAN Number</li>
            <li>✔ Email (Masked)</li>
            <li>✔ Mobile Number (Masked)</li>
            <li>✔ Date of Birth</li>
            <li>✔ Gender</li>
            <li>✔ Aadhaar Link Status / Number</li>
            <li>✔ Category</li>
            <li>✔ Full Address</li>
          </ul>

          <p className="note">
            Note: This is premium verified government level information.
          </p>
        </div>

      </div>



      {/* ================= HISTORY SECTION ================= */}
      <div className="pan-history">

        <h3>PAN Search History</h3>

        {history.length === 0 ? (
          <p className="empty">No records yet</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>PAN</th>
                <th>Full Name</th>
                <th>Father Name</th>
                <th>DOB</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Gender</th>
                <th>Aadhaar</th>
                <th>Category</th>
                <th>Address</th>
              </tr>
            </thead>

            <tbody>
              {history.map((h, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{h.pan}</td>
                  <td>{h.full_name}</td>
                  <td>{h.father_name || "—"}</td>
                  <td>{h.dob}</td>
                  <td>{h.email || "—"}</td>
                  <td>{h.phone || "—"}</td>
                  <td>{h.gender}</td>
                  <td>{h.aadhaar || "—"}</td>
                  <td>{h.category}</td>
                  <td>{h.address}</td>
                </tr>
              ))}
            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}
